import React from 'react';
import strings from '../../constants/strings';

const StatusPage = {
  NotFound: () => <p>{strings.en.httpStatus['404'].p1}</p>,
  NotAuthorized: () => <p>{strings.en.httpStatus['401'].p1}</p>,
};

export default StatusPage;
